import React from "react";
import styled from "styled-components";

const Container = styled.div`
    display: flex;
    align-items: center;
`;

const Status = styled.div`
    font-size: 14px;
    font-weight: 500;
    padding: 1px 8px;
    color: black;
    border-radius: 4px;
    background-color: ${({ backgroundColor }) => backgroundColor};
    text-transform: capitalize;
`;
const getStatusColor = (status) => {
    switch (status) {
        case "running":
            return "#6dccb1";
        case "paused":
            return "#FF7E62";
        case "off":
            return "#E0E5EE";
        default:
            return "#E0E5EE";
    }
};

const AutomationStatus = ({ status }) => {
    const backgroundColor = getStatusColor(status);

    return (
        <Container>
            <Status backgroundColor={backgroundColor}>{status}</Status>
        </Container>
    );
};

export default AutomationStatus;
